export enum FilterType {
    automatic = 0,
    text = 1,
    slider = 2,
    button = 3,
    list = 4,
    dropdown = 5,
    checkbox = 6
}